import { render, staticRenderFns } from "./AmountDetail.vue?vue&type=template&id=2e4c3e3c&scoped=true"
import script from "./AmountDetail.vue?vue&type=script&lang=ts"
export * from "./AmountDetail.vue?vue&type=script&lang=ts"
import style0 from "./AmountDetail.vue?vue&type=style&index=0&id=2e4c3e3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../DATA/projects/nguonhangchina/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4c3e3c",
  null
  
)

export default component.exports